import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useBooking } from '../context/BookingContext';
import '../styles/Navbar.css';

const Navbar = () => {
  const { language, setLanguage, t } = useLanguage();
  const { openBooking } = useBooking();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      setScrolled(isScrolled);
      if (typeof document !== 'undefined') {
        document.body.classList.toggle('nav-at-top', window.scrollY <= 20);
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? 'hidden' : 'unset';
  }, [mobileMenuOpen]);

  const navItems = ['home', 'services', 'prices', 'gallery', 'about', 'contact'];

  const handleNavClick = (item) => {
    setMobileMenuOpen(false);
    const element = document.getElementById(item);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${mobileMenuOpen ? 'menu-active' : ''}`}>
      <div className="navbar-container">

        {/* LOGO - Gauche */}
        <a href="#home" className="navbar-logo" onClick={() => handleNavClick('home')}>
          <div className="logo-icon">α</div>
          <div className="logo-text">
            <span className="logo-text-main">ALPHA BARBER</span>
            <span className="logo-text-sub">Beauty & Care</span>
          </div>
        </a>

        {/* LIENS - Centre */}
        <div className="navbar-center">
          <ul className="nav-links">
            {navItems.map((item) => (
              <li key={item}>
                <a
                  href={`#${item}`}
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item);
                  }}
                >
                  {t(`nav.${item}`)}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* ACTIONS - Droite */}
        <div className="navbar-right">
          <div className="language-toggle">
            <button
              className={`lang-btn ${language === 'fr' ? 'active' : ''}`}
              onClick={() => setLanguage('fr')}
            >
              FR
            </button>
            <span className="lang-separator">|</span>
            <button
              className={`lang-btn ${language === 'en' ? 'active' : ''}`}
              onClick={() => setLanguage('en')}
            >
              EN
            </button>
          </div>

          <button onClick={openBooking} className="nav-cta">
            <span>{t('nav.book')}</span>
          </button>
        </div>

        {/* MOBILE TOGGLE */}
        <button
          className={`mobile-menu-btn ${mobileMenuOpen ? 'open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className="menu-line"></span>
          <span className="menu-line"></span>
          <span className="menu-line"></span>
        </button>
      </div>

      {/* MOBILE MENU OVERLAY */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-bg"></div>
        <div className="mobile-menu-content">
          <ul className="mobile-nav-links">
            {navItems.map((item, index) => (
              <li key={item} style={{ transitionDelay: `${100 + index * 50}ms` }}>
                <a
                  href={`#${item}`}
                  className="mobile-nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item);
                  }}
                >
                  {t(`nav.${item}`)}
                </a>
              </li>
            ))}
          </ul>

          <div className="mobile-menu-footer">
            <div className="mobile-lang">
              <button className={language === 'fr' ? 'active' : ''} onClick={() => setLanguage('fr')}>FR</button>
              <button className={language === 'en' ? 'active' : ''} onClick={() => setLanguage('en')}>EN</button>
            </div>
            <button onClick={() => { setMobileMenuOpen(false); openBooking(); }} className="mobile-cta">
              {t('nav.book')}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;